<template>
  <div class="teachingActivity">
    <!-- 抢答详情 -->
    <div class="quick_box">
      <div class="rush_list" v-if="studentQuickList.length!=0">
        <div class="title"><img src="@/assets/img/image/title.png" alt="">抢答结果</div>
        <div class="list_box">
          <div class="list_item" v-for="(item,index) in studentQuickList">
            <div class="sort">
              <img v-if="index==0" src="@/assets/img/image/number1.png" alt="">
              <img v-else-if="index==1" src="@/assets/img/image/number1.png" alt="">
              <img v-else-if="index==2" src="@/assets/img/image/number1.png" alt="">
              <span v-else>{{ index+1 }}</span>
            </div>
            <div class="avator">
              <img v-if="!item.student.s_ico" src="../../../assets/images/user_img.png" alt="">
              <img v-else :src="item.student.s_ico" alt="">
            </div>
            <div class="info">
              <div>{{ item.student.s_name }}</div>
              <div class="timer">抢答时间:{{ item.student.timer }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <img src="../../../assets/img/image/noQuickAnswer.png" alt="">
        暂无人抢答
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "teacherTextbook",
  components: {},
  data() {
    return {
      studentQuickList: [],
      query: {},
    };
  },
  created() {
    this.query = JSON.parse(localStorage.getItem("query"));
    this.getQuickAnswerDetial();
  },

  methods: {
    // jdTActivitiesAnswer_recordInfo
    getQuickAnswerDetial() {
      this.$shttp.axiosPost(
        this.$api.jdTActivitiesAnswer_recordInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.studentQuickList = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
    
    <style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .quick_box {
    .rush_list {
      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
        line-height: 38px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        .img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
      }
      .list_box {
        margin-top: 20px;
        width: 550px;
        max-height: 600px;
        overflow-y: auto;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdcdc;
        .list_item {
          width: 100%;
          height: 68px;
          padding: 0 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          border-top: 1px solid #dcdcdc;
          &:nth-of-type(1) {
            border-top: none;
          }
          &:nth-of-type(2n-1) {
            background: #fafafa;
          }
          .sort {
            width: 30px;
            margin-right: 20px;
            img {
              width: 26px;
              height: 26px;
            }
          }
          .avator {
            width: 48px;
            height: 48px;
            border-radius: 100%;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 100%;
            }
          }
          .info {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            .timer {
              color: #999999;
              margin-top: 5px;
            }
          }
        }
      }
    }
    .noData {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 400px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      img {
        width: 370px;
        height: 200px;
      }
    }
  }
}
</style>